import axios from "axios";
import APILinks from "../links/links";

export default {
    refreshToken(body) {
        console.log("REFRESH TOKEN API", JSON.stringify(body));
        const headers = {
            "Content-Type": "application/json"
        };        
        return axios.post(APILinks.REFRESH_TOKEN, JSON.stringify(body), {
            headers: headers
        });
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/login/refreshTokenApi.js